import type { CourseStructureItem } from '@vedalib/editor/lib/elements'
import { useId } from 'react'

import type { ISectionTreeNode } from 'components/sections/ProjectStructure/utils'
import Collapse from 'components/uiKit/Collapse'

import { StructureNodeCourse } from './components/StructureNodeCourse'
import NavigationListStyled from '../../styled/NavigationListStyled'

interface ICourseStructure {
  nodes: ISectionTreeNode<CourseStructureItem>[]
  onSectionPick: (sectionId: string) => void
  initialOpen: boolean
  listId?: string
}

const CourseStructure: React.FC<ICourseStructure> = ({
  nodes,
  onSectionPick,
  initialOpen,
  listId,
}) => {
  const collapsedListId = useId()
  return (
    <NavigationListStyled id={listId} role='list'>
      {nodes.map((node) =>
        node.children?.length ? (
          <li key={node.item.id}>
            <Collapse
              header={(props) => (
                <StructureNodeCourse {...props} collapsedListId={collapsedListId} node={node} />
              )}
              initialOpen={initialOpen}
              name={node.item.name || node.item.id}
              styleType='ghost'
            >
              <CourseStructure
                initialOpen={initialOpen}
                listId={collapsedListId}
                nodes={node.children}
                onSectionPick={onSectionPick}
              />
            </Collapse>
          </li>
        ) : (
          <StructureNodeCourse
            key={node.item.id}
            node={node}
            onClick={() => onSectionPick(node.item.id)}
            open
          />
        ),
      )}
    </NavigationListStyled>
  )
}

export default CourseStructure
